export default __webpack_public_path__ + "static/media/151-printed.13202b3c.png";